import { BRAND } from '../config/brand'
export default {
  common: {
    appName: BRAND.fullProductNameAr,
    appDescription: 'نظام إدارة مشاريع المقاولات المتكامل',
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    create: 'إنشاء',
    search: 'بحث',
    filter: 'تصفية',
    actions: 'إجراءات',
    yes: 'نعم',
    no: 'لا',
    confirm: 'تأكيد',
    close: 'إغلاق',
    back: 'رجوع',
    next: 'التالي',
    previous: 'السابق',
    viewAll: 'عرض الكل',
    noData: 'لا توجد بيانات',
    error: 'حصل خطأ',
    success: 'تم بنجاح',
    required: 'مطلوب',
    optional: 'اختياري',
    all: 'الكل',
    clearFilter: 'ÙØ³Ø­ Ø§ÙÙØ±Ø´Ø­',
  },

  nav: {
    dashboard: 'الرئيسية',
    projects: 'المشاريع',
    companies: 'الشركات',
    clients: 'العملاء',
    consultants: 'الاستشاريين',
    suppliers: 'الموردون',
    team: 'الفريق',
    settings: 'الإعدادات',
    profile: 'الملف الشخصي',
    logout: 'تسجيل الخروج',
    reports: 'التقارير',
    portfolio: 'المحفظة',
    overheadPool: 'حوض المصروفات',
  },

  auth: {
    forgotPassword: 'نسيت كلمة المرور؟',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    register: 'إنشاء حساب',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    fullName: 'الاسم الكامل',
    username: 'اسم المستخدم',
    phone: 'رقم الهاتف',
    company: 'الشركة',
    role: 'الدور',
    rememberMe: 'تذكرني',
    loginButton: 'تسجيل الدخول',
    registerButton: 'إنشاء الحساب',
    loggingIn: 'جاري تسجيل الدخول...',
    noAccount: 'ليس لديك حساب؟',
    haveAccount: 'لديك حساب بالفعل؟',
    signUp: 'سجّل الآن',
    signIn: 'سجّل دخول',
    welcomeBack: 'مرحباً بعودتك',
    invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
  },

  dashboard: {
    welcome: 'مرحباً',
    overview: `نظرة عامة على نشاطك في ${BRAND.fullProductNameAr}`,
    totalCompanies: 'الشركات',
    totalProjects: 'المشاريع',
    activeProjects: 'المشاريع النشطة',
    contractValue: 'قيمة العقود',
    actualCost: 'التكلفة الفعلية',
    paidAmount: 'المبلغ المدفوع',
    boqSections: 'أقسام BOQ',
    boqValue: 'قيمة BOQ',
    recentProjects: 'آخر المشاريع',
    projectsByStatus: 'المشاريع حسب الحالة',
    projectsByType: 'المشاريع حسب النوع',
    projectsProgress: 'تقدم المشاريع',
    noProjects: 'لا توجد مشاريع بعد',
  },

  projects: {
    title: 'المشاريع',
    newProject: 'مشروع جديد',
    projectCount: '{{count}} مشروع',
    searchPlaceholder: 'ابحث بالاسم أو الكود...',
    noProjects: 'لا توجد مشاريع',
    startCreating: 'ابدأ بإنشاء مشروعك الأول',
    code: 'كود المشروع',
    name: 'اسم المشروع',
    nameAr: 'الاسم بالعربي',
    type: 'النوع',
    status: 'الحالة',
    priority: 'الأولوية',
    client: 'العميل',
    consultant: 'الاستشاري',
    location: 'الموقع',
    city: 'المدينة',
    country: 'الدولة',
    plotNumber: 'رقم القطعة',
    contractDate: 'تاريخ العقد',
    startDate: 'تاريخ البداية',
    plannedEndDate: 'تاريخ الانتهاء المخطط',
    actualEndDate: 'تاريخ الانتهاء الفعلي',
    duration: 'المدة (أيام)',
    contractValue: 'قيمة العقد',
    actualCost: 'التكلفة الفعلية',
    paidAmount: 'المبلغ المدفوع',
    currency: 'العملة',
    progress: 'التقدم',
    description: 'الوصف',
    scopeOfWork: 'نطاق العمل',
    notes: 'ملاحظات',
    statuses: {
      planning: 'تخطيط',
      tendering: 'عطاء',
      awarded: 'رسي',
      active: 'نشط',
      on_hold: 'متوقف',
      completed: 'مكتمل',
      cancelled: 'ملغي',
    },
    types: {
      residential: 'سكني',
      commercial: 'تجاري',
      industrial: 'صناعي',
      infrastructure: 'بنية تحتية',
      hospitality: 'ضيافة',
      healthcare: 'رعاية صحية',
      educational: 'تعليمي',
      religious: 'ديني',
      mixed_use: 'متعدد الاستخدام',
      renovation: 'تجديد',
      other: 'أخرى',
    },
    priorities: {
      low: 'منخفضة',
      medium: 'متوسطة',
      high: 'عالية',
      critical: 'حرجة',
    },
  },

  projectDetails: {
    backToProjects: 'الرجوع للمشاريع',
    overview: 'نظرة عامة',
    info: 'التفاصيل',
    boq: 'جدول الكميات',
    import: 'استيراد جدول الكميات',
    team: 'الفريق',
    documents: 'الملفات',
    downloadVariance: 'تقرير الانحراف',
    generating: 'جارٍ التوليد...',
    downloadVarianceError: 'فشل تحميل التقرير. حاول مرة أخرى.',
    openBoq: 'فتح BOQ',
    openFullBoq: 'فتح BOQ كامل',
    timeline: 'الجدول الزمني',
    location: 'الموقع',
    basicInfo: 'المعلومات الأساسية',
    parties: 'الأطراف',
    boqValue: 'قيمة BOQ',
    notFound: 'المشروع غير موجود',
    teamComingSoon: 'إدارة الفريق - قريباً',
    documentsComingSoon: 'إدارة الملفات - قريباً',

    // Sprint 3 Apex W2-J mirror tabs.
    qto: 'الحصر من المخططات',
    estimation: 'التسعير',
    materials: 'المواد',
    costComparison: 'مقارنة التكاليف',
    qtoMissingProject: 'لا يوجد مشروع محمَّل — لا يمكن فتح مساحة الحصر.',
    estimationMissingProject: 'لا يوجد مشروع محمَّل — لا يمكن فتح شبكة التسعير.',
    materialsTitle: 'مواد المشروع (BOM)',
    materialsSubtitle:
      'ثبّت بنود الـ BOM لهذا المشروع. الأسعار المثبتة تغذي شبكة التسعير ومقارنة التكاليف.',
    materialsAdd: 'إضافة مادة',
    materialsEmptyTitle: 'لا توجد مواد مثبتة لهذا المشروع بعد',
    materialsEmptyHint: 'اضغط «إضافة مادة» لاختيار بند من كتالوج الـ BOM.',
    materialsRemove: 'إزالة المادة من المشروع',
    materialsCol: {
      code: 'الكود',
      name: 'الاسم',
      unit: 'الوحدة',
      lockedRate: 'السعر المثبت',
      source: 'مصدر السعر',
      actions: 'إجراءات',
    },
    costComparisonTitle: 'المخطَّط مقابل الفعلي',
    costComparisonSubtitle:
      'مؤشرات الانحراف تتبع عتبات ORKSTRA المعيارية. اضغط بنداً للتعمق.',
    ccBreadcrumb: 'تنقل تفصيل مقارنة التكاليف',
    ccBreadcrumbProject: 'المشروع',
    ccBreadcrumbSection: 'القسم',
    ccBreadcrumbItem: 'البند',
  },

  companies: {
    title: 'الشركات',
    newCompany: 'شركة جديدة',
    companyCount: '{{count}} شركة',
    searchPlaceholder: 'ابحث بالاسم أو الرخصة...',
    noCompanies: 'لا توجد شركات',
    startCreating: 'ابدأ بإضافة شركتك الأولى',
    name: 'اسم الشركة',
    nameAr: 'الاسم بالعربي',
    type: 'نوع الشركة',
    tradeLicense: 'الرخصة التجارية',
    taxNumber: 'الرقم الضريبي',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    website: 'الموقع الإلكتروني',
    address: 'العنوان',
    city: 'المدينة',
    country: 'الدولة',
    bankName: 'اسم البنك',
    bankAccount: 'رقم الحساب',
    iban: 'الآيبان',
    description: 'الوصف',
    types: {
      contractor: 'مقاول رئيسي',
      subcontractor: 'مقاول فرعي',
      consultant: 'استشاري',
      supplier: 'مورد',
      client: 'عميل',
    },
  },

  clients: {
    title: 'العملاء',
    clientLabel: 'عميل',
    clientCount: '{{count}} عميل',
    searchPlaceholder: 'ابحث بالاسم...',
    noClients: 'لا يوجد عملاء',
    clientsDerivedFromProjects: 'يظهر العملاء تلقائياً من المشاريع',
    clientNotFoundDescription: 'لا يوجد عميل بالاسم "{{name}}" في أي مشروع',
    notFound: 'العميل غير موجود',
    backToClients: 'الرجوع للعملاء',
    projects: 'المشاريع',
    active: 'نشط',
    completed: 'مكتمل',
    totalContractValue: 'إجمالي قيمة العقود',
    projectsList: 'قائمة المشاريع',
  },

  consultants: {
    title: 'الاستشاريين',
    consultantLabel: 'استشاري',
    consultantCount: '{{count}} استشاري',
    searchPlaceholder: 'ابحث بالاسم...',
    noConsultants: 'لا يوجد استشاريون',
    consultantsDerivedFromProjects: 'يظهر الاستشاريون تلقائياً من المشاريع',
    consultantNotFoundDescription: 'لا يوجد استشاري بالاسم "{{name}}" في أي مشروع',
    notFound: 'الاستشاري غير موجود',
    backToConsultants: 'الرجوع للاستشاريين',
    projects: 'المشاريع',
    active: 'نشط',
    completed: 'مكتمل',
    totalContractValue: 'إجمالي قيمة العقود',
    projectsList: 'قائمة المشاريع',
  },

  boq: {
    title: 'جدول الكميات',
    subtitle: 'BOQ - Bill of Quantities',
    grandTotal: 'الإجمالي الكلي',
    totalSections: 'الأقسام',
    totalItems: 'البنود',
    addSection: 'إضافة قسم',
    addItem: 'إضافة بند',
    editSection: 'تعديل القسم',
    editItem: 'تعديل البند',
    sectionCode: 'كود القسم',
    sectionName: 'اسم القسم',
    sectionNameAr: 'اسم القسم بالعربي',
    itemCode: 'كود البند',
    description: 'الوصف',
    descriptionAr: 'الوصف بالعربي',
    unit: 'الوحدة',
    quantity: 'الكمية',
    unitRate: 'سعر الوحدة',
    total: 'الإجمالي',
    isSubtotal: 'عنوان فرعي (بدون سعر)',
    displayOrder: 'الترتيب',
    notes: 'ملاحظات',
    specification: 'المواصفات',
    sectionTotal: 'إجمالي القسم',
    noSections: 'لا توجد أقسام في هذا المشروع',
    addFirstSection: 'ابدأ بإضافة أول قسم',
    noItems: 'لا توجد بنود',
    selectProject: 'اختر مشروع',
    backToProjects: 'الرجوع للمشاريع',
    export: 'تصدير لـ Excel',
    exporting: 'جاري التصدير...',
    exportPdf: 'تصدير PDF',
    exportingPdf: 'جاري إنشاء PDF...',
    import: 'استيراد من Excel',
    importing: 'جاري الاستيراد...',
    downloadTemplate: 'تنزيل القالب',
    uploadFile: 'رفع ملف Excel',
    importPreview: 'معاينة الاستيراد',
    confirmImport: 'تأكيد الاستيراد',
    importInstructions: 'حمّل القالب، املأه ببياناتك، ثم ارفعه',
    mapping: {
      searchPlaceholder: 'بحث بالكود أو الوصف أو الوحدة…',
      filterAll: 'الكل',
      filterUnassigned: 'غير مربوط',
      filterPartial: 'مربوط جزئيًا',
      filterComplete: 'مربوط بالكامل',
      sortNone: 'الترتيب الافتراضي',
      sortLinked: 'ترتيب حسب الربط',
      sortVariance: 'ترتيب حسب الفرق',
      selectUnassigned: 'تحديد البنود غير المربوطة',
      clearSelection: 'مسح التحديد',
      selectedCount: 'تم تحديد {{count}}',
      bulkAutoSuggest: 'اقتراح ربط تلقائي',
      bulkClear: 'مسح الربط',
      bulkRecalc: 'إعادة حساب الكميات',
      linked: 'مربوط',
      manualQty: 'الكمية اليدوية',
      autoQty: 'الكمية المربوطة آليًا',
      variance: 'الفرق',
      status: 'الحالة',
      status_unassigned: 'غير مربوط',
      status_partial: 'جزئي',
      status_complete: 'مكتمل',
      noMatches: 'لا توجد بنود تطابق الفلاتر الحالية',
      pageSizeHint: 'عرض {{shown}} من إجمالي {{total}} بند',
    },
    units: {
      no: 'عدد',
      m: 'متر',
      m2: 'متر مربع',
      m3: 'متر مكعب',
      kg: 'كجم',
      ton: 'طن',
      lump: 'مقطوع',
      lot: 'إجمالي',
      hr: 'ساعة',
      day: 'يوم',
      ls: 'مقطوع',
    },
  },

  profile: {
    title: 'الملف الشخصي',
    subtitle: 'إدارة بياناتك و إعدادات حسابك',
    viewProfile: 'عرض الملف الشخصي',
    personalInfo: 'البيانات الشخصية',
    accountInfo: 'معلومات الحساب',
    security: 'الأمان',
    memberSince: 'مسجّل منذ',
    lastLogin: 'آخر تسجيل دخول',
    never: 'لم يسجّل دخول',
    active: 'نشط',
    inactive: 'غير نشط',
    verified: 'موثّق',
    changePassword: 'تغيير كلمة المرور',
    changePasswordDescription: 'حدّث كلمة المرور بانتظام للحفاظ على أمان حسابك',
    change: 'تغيير',
    changing: 'جاري التغيير...',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmNewPassword: 'تأكيد كلمة المرور الجديدة',
    currentPasswordRequired: 'لازم تدخل كلمة المرور الحالية',
    newPasswordRequired: 'لازم تدخل كلمة المرور الجديدة',
    passwordTooShort: 'كلمة المرور لازم تكون 8 أحرف على الأقل',
    samePassword: 'كلمة المرور الجديدة لازم تكون مختلفة عن القديمة',
    passwordMismatch: 'كلمتا المرور مش متطابقتين',
    passwordChangedSuccess: 'تم تغيير كلمة المرور بنجاح',
    passwordRequirements: '8 أحرف على الأقل. يفضّل خليط من الحروف الكبيرة و الصغيرة و الأرقام و الرموز',
    passwordSecurityTitle: 'أمان كلمة المرور',
    passwordSecurityHint: 'استخدم كلمة مرور قوية و مش مستخدمها في حسابات تانية',
    passwordStrength: 'قوة كلمة المرور',
    passwordWeak: 'ضعيفة',
    passwordMedium: 'متوسطة',
    passwordStrong: 'قوية',
  },

  team: {
    title: 'إدارة الفريق',
    subtitle: 'إدارة المستخدمين و الصلاحيات',
    userCount: '{{count}} مستخدم',
    searchPlaceholder: 'ابحث بالاسم أو الإيميل...',
    newUser: 'مستخدم جديد',
    noUsers: 'لا يوجد مستخدمون',
    startCreating: 'ابدأ بإضافة أعضاء فريقك',
    you: 'أنت',
    isActive: 'نشط',
    isVerified: 'موثّق',
    deactivate: 'تعطيل',
    deactivateUser: 'تعطيل المستخدم',
    deactivateConfirm: 'هل أنت متأكد من تعطيل المستخدم',
    resetPassword: 'إعادة تعيين كلمة المرور',
    resetPasswordWarning: 'سيتم تغيير كلمة مرور المستخدم. يجب تسليمها له لاحقاً بطريقة آمنة.',
    resetPasswordHint: 'كلمة مرور جديدة قوية. ستسلّمها للمستخدم في رسالة آمنة.',
    resetPasswordSuccess: 'تم إعادة تعيين كلمة المرور بنجاح',
    userCreatedSuccess: 'تم إنشاء المستخدم بنجاح',
    userDeactivatedSuccess: 'تم تعطيل المستخدم',
    accessDenied: 'الوصول مرفوض',
    adminOnlyAccess: 'هذه الصفحة متاحة لمديري النظام فقط',
    allRoles: 'كل الأدوار',
    selectRole: '— اختر الدور —',
    currentRole: 'الدور الحالي',
    noRoleAssigned: 'لا يوجد دور',
    rolesLoadFailed: 'تعذّر تحميل قائمة الأدوار',
    roleNotInCatalogue: '(غير موجود في قائمة الأدوار)',
    roleNotInCatalogueHint:
      'المستخدم ده دوره مش موجود في قائمة أدوار الشركة. الحفظ هيسيبه زي ما هو غير لما تختار دور تاني.',
  },

  documents: {
    title: 'الملفات',
    subtitle: 'إدارة العقود والفواتير والصور',
    documentCount: '{{count}} ملف',
    searchPlaceholder: 'ابحث بالاسم أو الوصف...',
    uploadDocument: 'رفع ملف',
    upload: 'رفع',
    uploading: 'جاري الرفع...',
    uploadSuccess: 'تم رفع الملف بنجاح',
    deleteDocument: 'حذف الملف',
    deleteConfirm: 'هل أنت متأكد من حذف الملف',
    deleteSuccess: 'تم حذف الملف',
    download: 'تحميل',
    noDocuments: 'لا توجد ملفات',
    startUploading: 'ابدأ برفع الملفات للمشروع',
    documentName: 'اسم الملف',
    documentNameAr: 'الاسم بالعربي',
    namePlaceholder: 'مثلاً: عقد المقاولة',
    nameArPlaceholder: 'مثلاً: عقد المقاولة',
    description: 'الوصف',
    descriptionPlaceholder: 'وصف اختياري للملف',
    category: 'الفئة',
    allCategories: 'كل الفئات',
    nameRequired: 'لازم تدخل اسم للملف',
    selectFile: 'اختر ملف للرفع',
    fileTooLarge: 'حجم الملف أكبر من 10 ميجابايت',
    dragDropHint: 'اسحب الملف هنا',
    orClickToSelect: 'أو اضغط للاختيار',
    maxFileSize: 'حد أقصى 10MB',
    supportedFormats: 'PDF، Word، Excel، صور، DWG وغيرها',
    categories: {
      contract: 'عقود',
      invoice: 'فواتير',
      payment: 'مدفوعات',
      drawing: 'رسومات',
      photo: 'صور',
      report: 'تقارير',
      permit: 'تصاريح',
      insurance: 'تأمينات',
      boq: 'جداول كميات',
      specification: 'مواصفات',
      correspondence: 'مراسلات',
      other: 'أخرى',
    },
  },

  forgotPassword: {
    title: 'نسيت كلمة المرور؟',
    subtitle: 'أدخل بريدك الإلكتروني و هنبعتلك رابط لإعادة التعيين',
    sendResetLink: 'إرسال رابط إعادة التعيين',
    sending: 'جاري الإرسال...',
    backToLogin: 'العودة لتسجيل الدخول',
    checkEmail: 'تحقّق من بريدك الإلكتروني!',
    emailSentTo: 'بعتنا رابط إعادة التعيين على:',
    nextSteps: 'الخطوات التالية:',
    step1: 'افتح بريدك الإلكتروني',
    step2: `دوّر على email من ${BRAND.fullProductNameAr}`,
    step3: 'اضغط على زرار "إعادة تعيين كلمة المرور"',
    linkExpires: 'الرابط صالح لمدة 60 دقيقة فقط',
  },

  resetPassword: {
    title: 'إعادة تعيين كلمة المرور',
    forAccount: 'للحساب:',
    resetButton: 'تأكيد كلمة المرور الجديدة',
    resetting: 'جاري التعيين...',
    success: 'تم تغيير كلمة المرور بنجاح!',
    invalidToken: 'الرابط غير صالح',
    invalidTokenDesc: 'الرابط منتهي الصلاحية أو تم استخدامه مسبقاً',
    noToken: 'رابط غير صالح',
    noTokenDesc: 'لم يتم العثور على token في الرابط',
    requestNew: 'طلب رابط جديد',
  },
reports: {
  title: 'التقارير و التحليلات',
  subtitle: 'نظرة شاملة على أداء المشاريع',
  totalProjects: 'إجمالي المشاريع',
  totalValue: 'القيمة الإجمالية',
  active: 'نشط',
  contractsValue: 'قيمة العقود',
  teamMembers: 'أعضاء الفريق',
  activeUsers: 'مستخدمين نشطين',
  documents: 'الوثائق',
  allDocs: 'كل الوثائق',
  financialOverview: 'النظرة المالية',
  totalRevenue: 'إجمالي الإيرادات',
  totalCost: 'إجمالي التكاليف',
  estimatedProfit: 'الربح المقدّر',
  margin: 'هامش الربح',
  projectsBreakdown: 'تفاصيل المشاريع',
  project: 'المشروع',
  contractValue: 'قيمة العقد',
  boqTotal: 'إجمالي BOQ',
  profit: 'الربح',
  marginPct: 'الهامش',
  projectsByStatus: 'المشاريع حسب الحالة',
},

  roles: {
    admin: 'مدير النظام',
    project_manager: 'مدير مشاريع',
    engineer: 'مهندس',
    accountant: 'محاسب',
    viewer: 'مشاهد',
  },

  portfolio: {
    title: 'لوحة المحفظة',
    subtitle: 'نظرة تنفيذية على جميع المشاريع',
    refresh: 'تحديث',
    downloadPdf: 'تحميل ملخص المحفظة',
    downloading: 'جارٍ توليد PDF...',
    downloadError: 'فشل تحميل التقرير. يُرجى المحاولة مرة أخرى.',
    refreshing: 'جاري التحديث...',
    lastUpdated: 'آخر تحديث',

    metrics: {
      activeProjects: 'المشاريع النشطة',
      activeProjectsHint: 'في المحفظة حالياً',
      totalContract: 'إجمالي قيمة العقود',
      paid: 'مدفوع',
      totalBac: 'إجمالي الميزانية المعتمدة',
      weightedSpiCpi: 'SPI / CPI المرجّح',
      avgProgress: 'متوسط الإنجاز',
      trueCost: 'التكلفة الفعلية',
      marginTheoretical: 'هامش الربح (نظري)',
      marginTheoreticalHint: 'قيمة العقد - التكلفة الفعلية',
      marginCollected: 'هامش الربح (محصّل)',
      marginCollectedHint: 'المحصّل - التكلفة الفعلية',
      weightedRisk: 'درجة المخاطر المرجّحة',
      atRiskShort: 'مشروع في خطر',
    },

    riskLevel: {
      healthy: 'سليم',
      watch: 'تحت المراقبة',
      at_risk: 'في خطر',
      critical: 'حرج',
    },

    riskDistribution: {
      title: 'توزيع المخاطر',
      filteredBy: 'ÙØ±Ø´Ø­ Ø­Ø³Ø¨',
    },

    projects: {
      title: 'المشاريع',
    },

    project: {
      contract: 'العقد',
      bac: 'الميزانية',
      progress: 'الإنجاز',
    },

    empty: {
      noProjects: 'لا توجد مشاريع في المحفظة بعد',
    },

    modal: {
      financial: 'نظرة مالية',
      performance: 'الأداء',
      riskBreakdown: 'تفصيل المخاطر',
      scheduleRisk: 'مخاطر الجدول الزمني',
      costRisk: 'مخاطر التكلفة',
      criticalPathRisk: 'مخاطر المسار الحرج',
      liquidityRisk: 'مخاطر السيولة',
      totalRisk: 'إجمالي درجة المخاطر',
      timeline: 'الجدول الزمني',
      startDate: 'تاريخ البداية',
      plannedEnd: 'النهاية المخططة',
      openProject: 'فتح المشروع',
      computationError: 'خطأ في الحساب',
    },

        error: {
      loadFailed: 'فشل تحميل بيانات المحفظة. حاول التحديث.',
    },
  },

  overhead: {
    title: 'حوض المصروفات العامة',
    subtitle: 'إدارة قيم المصروفات العامة الشهرية لتوزيعها على المشاريع',
    addEntry: 'إضافة قيد',
    addFirst: 'إضافة أول قيد',
    grandTotal: 'الإجمالي',
    byCategory: 'حسب الفئة',
    entries: 'القيود',
    
    form: {
      year: 'السنة',
      month: 'الشهر',
      category: 'الفئة',
      amount: 'المبلغ',
      description: 'الوصف',
      descriptionPlaceholder: 'ملاحظات اختيارية عن هذا القيد...',
      editingHint: 'لتغيير الفئة/الفترة، احذف القيد وأضف قيداً جديداً',
    },
    
    categories: {
      salaries: 'الرواتب والأجور',
      office: 'مصاريف المكتب',
      depreciation: 'الإهلاك',
      software: 'البرمجيات وتقنية المعلومات',
      insurance: 'التأمين',
      banking: 'المصرفية والمالية',
      professional: 'الأتعاب المهنية',
      other: 'أخرى',
    },
    
    modal: {
      addTitle: 'إضافة قيد مصروف عام',
      editTitle: 'تعديل قيد مصروف عام',
    },
    
    empty: {
      noEntries: 'لا توجد قيود مصروفات لهذه الفترة بعد.',
    },
    
    errors: {
      invalidAmount: 'الرجاء إدخال مبلغ صحيح أكبر من الصفر',
      logoUploadSuccess: 'تم رفع الشعار بنجاح',
    logoDeleteSuccess: 'تم حذف الشعار بنجاح',
    saveFailed: 'فشل حفظ القيد. حاول مرة أخرى.',
      loadFailed: 'فشل تحميل بيانات المصروفات',
    },
  },

  settings: {
    title: 'إعدادات الشركة',
    subtitle: 'إدارة هوية الشركة ومعلومات الاتصال والبيانات القانونية',
    branding: 'الهوية البصرية',
    contact: 'معلومات الاتصال',
    legal: 'البيانات القانونية',
    logo: 'شعار الشركة',
    logoEmpty: 'لم يتم رفع شعار بعد. ارفع صورة PNG أو JPEG أو WebP (بحد أقصى 2 ميجا).',
    logoCurrent: 'الشعار الحالي',
    logoUpload: 'رفع شعار',
    logoReplace: 'استبدال',
    logoRemove: 'حذف',
    logoDeleteConfirm: 'هل أنت متأكد من حذف شعار الشركة؟',
    logoUploadFailed: 'فشل رفع الشعار. حاول مرة أخرى.',
    logoDeleteFailed: 'فشل حذف الشعار. حاول مرة أخرى.',
    logoErrorType: 'نوع الملف غير مدعوم. الأنواع المسموحة: PNG, JPEG, WebP.',
    logoErrorSize: 'حجم الملف كبير جداً. الحد الأقصى 2 ميجا.',
    primaryColor: 'اللون الأساسي',
    secondaryColor: 'اللون الثانوي',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    website: 'الموقع الإلكتروني',
    addressEn: 'العنوان (إنجليزي)',
    addressAr: 'العنوان (عربي)',
    taxNumber: 'الرقم الضريبي',
    tradeLicense: 'رقم الرخصة التجارية',
    savedSuccess: 'تم حفظ الإعدادات بنجاح',
    saveFailed: 'فشل حفظ الإعدادات',
    // S49: tenant display preferences
    displayPrefs: 'تفضيلات العرض',
    calendarPreference: 'التقويم المفضل',
    calendarGregorian: 'ميلادي فقط',
    calendarHijri: 'هجري فقط',
    calendarBoth: 'الاثنان (ميلادي + هجري)',
    defaultCurrency: 'العملة الافتراضية',
    defaultCurrencyHint: 'تُستخدم كقيمة افتراضية عندما لا يحدد السجل عملة.',
  },

  // Module 2.3 — Document Management System
  dms: {
    title: 'إدارة المستندات',
    dashboard: 'لوحة المستندات',
    drawings: 'المخططات',
    submittals: 'العينات والمستندات الفنية',
    rfis: 'طلبات التوضيح',
    transmittals: 'الإرساليات',
    markups: 'تعليقات PDF',
    counters: {
      drawingsTotal: 'إجمالي المخططات',
      drawingsForConstruction: 'جاهزة للتنفيذ',
      submittalsOpen: 'مستندات مفتوحة',
      submittalsOverdue: 'مستندات متأخرة',
      rfisOpen: 'طلبات توضيح مفتوحة',
      rfisOverdue: 'طلبات متأخرة',
      transmittalsThisMonth: 'إرساليات هذا الشهر',
    },
    drawing: {
      number: 'رقم المخطط',
      title: 'العنوان',
      discipline: 'التخصص',
      revision: 'المراجعة',
      revisions: 'المراجعات',
      currentRevision: 'المراجعة الحالية',
      uploadRevision: 'رفع مراجعة',
      newDrawing: 'مخطط جديد',
      uploadedAt: 'تاريخ الرفع',
      uploadedBy: 'رفع بواسطة',
      fileSize: 'حجم الملف',
      notes: 'ملاحظات',
      empty: 'لا توجد مخططات بعد. أضف واحداً لبدء السجل.',
    },
    submittal: {
      number: 'رقم المستند',
      subject: 'الموضوع',
      priority: 'الأولوية',
      submit: 'تقديم',
      respond: 'رد',
      close: 'إغلاق',
      consultantDue: 'استحقاق الاستشاري',
      responseHistory: 'سجل الردود',
      specSection: 'قسم المواصفات',
      newSubmittal: 'مستند جديد',
      empty: 'لا توجد مستندات بعد.',
    },
    rfi: {
      number: 'رقم الطلب',
      subject: 'الموضوع',
      question: 'السؤال',
      respond: 'رد',
      close: 'إغلاق',
      consultantDue: 'استحقاق الاستشاري',
      answeredAt: 'تم الرد في',
      newRfi: 'طلب توضيح جديد',
      empty: 'لا توجد طلبات بعد.',
      isFinal: 'وضع كرد نهائي',
      costImpact: 'الأثر على التكلفة (درهم)',
      scheduleImpact: 'الأثر على الجدول (أيام)',
    },
    transmittal: {
      number: 'رقم الإرسالية',
      subject: 'الموضوع',
      purpose: 'الغرض',
      recipientCompany: 'الجهة المستلمة',
      recipientEmails: 'بريد المستلمين',
      send: 'إرسال',
      acknowledge: 'إقرار الاستلام',
      sentAt: 'تاريخ الإرسال',
      acknowledgedAt: 'تاريخ الإقرار',
      items: 'البنود',
      addItem: 'إضافة بند',
      newTransmittal: 'إرسالية جديدة',
      empty: 'لا توجد إرساليات بعد.',
    },
    status: {
      draft: 'مسودة',
      submitted: 'مُقدَّم',
      reviewing: 'قيد المراجعة',
      approved: 'معتمد',
      approved_with_comments: 'معتمد مع ملاحظات',
      rejected: 'مرفوض',
      resubmit_required: 'يجب إعادة التقديم',
      closed: 'مغلق',
      open: 'مفتوح',
      answered: 'تم الرد',
      void: 'لاغٍ',
      sent: 'مُرسَل',
      acknowledged: 'مؤكَّد الاستلام',
      for_construction: 'للتنفيذ',
      superseded: 'مستبدل',
      archived: 'مؤرشف',
    },
    priority: {
      low: 'منخفضة',
      normal: 'عادية',
      high: 'عالية',
      urgent: 'عاجلة',
    },
    purpose: {
      for_information: 'للعلم',
      for_review: 'للمراجعة',
      for_approval: 'للاعتماد',
      for_construction: 'للتنفيذ',
    },
    activity: {
      drawing_uploaded: 'تم رفع مخطط',
      submittal_submitted: 'تم تقديم مستند',
      submittal_responded: 'تم الرد على مستند',
      rfi_asked: 'تم طرح طلب توضيح',
      rfi_answered: 'تم الرد على طلب توضيح',
      transmittal_sent: 'تم إرسال إرسالية',
    },
    common: {
      noProject: 'اختر مشروعاً لعرض بيانات المستندات.',
      loading: 'جارٍ التحميل…',
      saved: 'تم الحفظ',
      saveFailed: 'فشل الحفظ',
    },
  },

  // === AGENT_A (M2.8 Workforce + Payroll) BEGIN ===
  workforce: {
    nav: 'الموارد البشرية',
    backToList: 'العودة للقائمة',
    hiredOn: 'تاريخ التعيين',
    employees: {
      title: 'الموظفون',
      count: '{{count}} موظف',
      searchPlaceholder: 'ابحث بالاسم أو الكود أو الهوية…',
      new: 'موظف جديد',
      empty: 'لا يوجد موظفون',
      emptyHint: 'ابدأ بإضافة أول موظف.',
    },
    departments: {
      title: 'الإدارات',
      count: '{{count}} إدارة',
      empty: 'لا توجد إدارات بعد',
    },
    leave: {
      title: 'طلبات الإجازة',
      subtitle: '{{count}} طلب في هذا العرض',
      empty: 'لا توجد طلبات إجازة',
      employee: 'الموظف',
      days: 'يوم',
      approve: 'موافقة',
      reject: 'رفض',
      rejectTitle: 'رفض طلب الإجازة',
      rejectPrompt: 'سبب الرفض (اختياري).',
      reasonPlaceholder: 'مثلاً: ضغط العمل في هذه الفترة',
      confirmReject: 'تأكيد الرفض',
      noBalances: 'لا يوجد رصيد إجازة لهذا العام بعد.',
      allocated: 'المخصص',
      used: 'المستخدم',
      pending: 'قيد الموافقة',
      available: 'المتاح',
    },
    attendance: {
      title: 'الحضور',
      subtitle: 'نظرة عامة على الحضور اليومي',
      workDate: 'تاريخ العمل',
      total: 'السجلات',
      totalHours: 'إجمالي الساعات',
      overtimeHours: 'الساعات الإضافية',
      present: 'حاضر',
      employee: 'الموظف',
      clockIn: 'تسجيل الدخول',
      clockOut: 'تسجيل الانصراف',
      hours: 'الساعات',
      overtime: 'الإضافية',
      statusCol: 'الحالة',
      empty: 'لا توجد سجلات حضور لهذا التاريخ',
      openDashboard: 'افتح لوحة الحضور لرؤية السجل الكامل.',
    },
    documents: {
      empty: 'لم يتم رفع أي مستندات بعد',
      expires: 'تنتهي في',
    },
    contracts: {
      empty: 'لا توجد عقود بعد',
    },
    tabs: {
      profile: 'الملف الشخصي',
      documents: 'المستندات',
      contracts: 'العقود',
      attendance: 'الحضور',
      leave: 'الإجازات',
    },
    fields: {
      nationality: 'الجنسية',
      emiratesId: 'الهوية الإماراتية',
      passportNo: 'رقم الجواز',
      dob: 'تاريخ الميلاد',
      gender: 'الجنس',
      maritalStatus: 'الحالة الاجتماعية',
      hireDate: 'تاريخ التعيين',
      terminationDate: 'تاريخ الإنهاء',
      contactEmail: 'البريد الإلكتروني',
      contactPhone: 'الهاتف',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      basicSalary: 'الراتب الأساسي',
      workingHours: 'ساعات العمل',
    },
    employmentStatus: {
      active: 'نشط',
      on_leave: 'في إجازة',
      suspended: 'موقوف',
      terminated: 'منهي خدمته',
      resigned: 'مستقيل',
    },
    gender: {
      male: 'ذكر',
      female: 'أنثى',
    },
    maritalStatus: {
      single: 'أعزب',
      married: 'متزوج',
      divorced: 'مطلق',
      widowed: 'أرمل',
    },
    contractType: {
      unlimited: 'غير محدد',
      limited: 'محدد المدة',
      part_time: 'دوام جزئي',
      temporary: 'مؤقت',
    },
    contractStatus: {
      draft: 'مسودة',
      active: 'نشط',
      expired: 'منتهٍ',
      terminated: 'منهي',
    },
    documentType: {
      emirates_id: 'الهوية الإماراتية',
      passport: 'جواز السفر',
      visa: 'التأشيرة',
      work_permit: 'تصريح العمل',
      labour_card: 'بطاقة العمل',
      education: 'الشهادات الدراسية',
      health_insurance: 'التأمين الصحي',
      other: 'أخرى',
    },
    leaveStatus: {
      draft: 'مسودة',
      pending: 'قيد المراجعة',
      approved: 'تمت الموافقة',
      rejected: 'مرفوض',
      cancelled: 'ملغى',
    },
    attendanceStatus: {
      present: 'حاضر',
      absent: 'غائب',
      half_day: 'نصف يوم',
      on_leave: 'في إجازة',
      holiday: 'عطلة رسمية',
      weekend: 'عطلة أسبوعية',
    },
  },

  payroll: {
    periods: {
      title: 'فترات الرواتب',
      count: '{{count}} فترة',
      new: 'فترة جديدة',
      newTitle: 'فترة رواتب جديدة',
      year: 'السنة',
      month: 'الشهر',
      empty: 'لا توجد فترات رواتب بعد',
      emptyHint: 'أنشئ أول فترة رواتب للبدء.',
      createFailed: 'تعذّر إنشاء الفترة (تكرار أو خطأ تحقق).',
    },
    runs: {
      backToPeriods: 'العودة للفترات',
      headerTitle: 'رواتب {{year}}-{{month}}',
      step: 'خطوة',
      steps: {
        review: 'مراجعة',
        calculate: 'حساب',
        post: 'اعتماد',
        wps: 'تصدير WPS',
      },
      reviewTitle: 'جاهز للبدء',
      reviewHint: 'ابدأ تشغيل الرواتب لهذه الفترة.',
      initiate: 'بدء التشغيل',
      calculateTitle: 'حساب كشوف المرتبات',
      calculateHint: 'تشغيل الحاسبة على كل الموظفين النشطين.',
      calculate: 'احسب',
      calculating: 'جارٍ الحساب…',
      recalculate: 'إعادة الحساب',
      post: 'اعتماد التشغيل',
      openWps: 'فتح تصدير WPS',
      employee: 'الموظف',
      basic: 'الأساسي',
      allowances: 'البدلات',
      overtime: 'الإضافي',
      deductions: 'الاستقطاعات',
      net: 'الصافي',
      totalGross: 'إجمالي الراتب',
      totalDeductions: 'إجمالي الاستقطاعات',
      totalGOSI: 'إجمالي التأمينات',
      totalNet: 'إجمالي الصافي',
    },
    payslip: {
      title: 'كشف الراتب',
      runEmployee: 'تشغيل #{{run}} · موظف #{{employee}}',
      downloadPdf: 'تنزيل PDF',
      earnings: 'الاستحقاقات',
      deductions: 'الاستقطاعات',
      basic: 'الراتب الأساسي',
      allowances: 'البدلات',
      overtime: 'العمل الإضافي',
      gross: 'إجمالي الراتب',
      gosi: 'التأمينات الاجتماعية',
      totalDeductions: 'إجمالي الاستقطاعات',
      netPay: 'صافي الراتب',
    },
    wps: {
      title: 'تصدير WPS SIF',
      subtitle: 'إنشاء ملفات نظام حماية الأجور للتقديم البنكي.',
      generateTitle: 'إنشاء ملف SIF جديد',
      submitterCode: 'رمز المُقدِّم',
      employerId: 'معرّف صاحب العمل',
      bankCode: 'رمز البنك',
      paymentDate: 'تاريخ الدفع',
      generate: 'إنشاء SIF',
      generateFailed: 'فشل الإنشاء. يجب اعتماد التشغيل أولاً.',
      empty: 'لا توجد دفعات WPS لهذا التشغيل بعد.',
      batch: 'دفعة',
      submit: 'تقديم للبنك',
      accept: 'تأكيد القبول',
    },
    gratuity: {
      title: 'حاسبة نهاية الخدمة',
      subtitle: 'تسوية نهاية الخدمة وفق مرسوم بقانون اتحادي 33/2021.',
      employeeId: 'رقم الموظف',
      reason: 'السبب',
      serviceEnd: 'تاريخ انتهاء الخدمة',
      basicSalary: 'الراتب الأساسي',
      useContractDefault: 'يستخدم راتب العقد النشط افتراضياً',
      priorDeductions: 'استقطاعات سابقة',
      calculate: 'احسب',
      calcFailed: 'فشل الحساب.',
      resultTitle: 'نتيجة الحساب',
      yearsOfService: 'سنوات الخدمة',
      dailyWage: 'الأجر اليومي',
      first5Days: 'أيام أول 5 سنوات',
      after5Days: 'أيام بعد 5 سنوات',
      capApplied: 'تم تطبيق سقف المادة 54 ({{cap}} درهم)',
      totalGratuity: 'إجمالي مكافأة نهاية الخدمة',
    },
    periodStatus: {
      draft: 'مسودة',
      locked: 'مقفلة',
      posted: 'معتمدة',
      cancelled: 'ملغاة',
    },
    runStatus: {
      pending: 'بانتظار',
      calculating: 'جارٍ الحساب',
      calculated: 'تم الحساب',
      failed: 'فشل',
      posted: 'معتمد',
    },
    wpsStatus: {
      generated: 'تم الإنشاء',
      submitted: 'تم التقديم',
      accepted: 'مقبول',
      rejected: 'مرفوض',
    },
    gratuityReason: {
      termination: 'إنهاء خدمة',
      resignation: 'استقالة',
      end_of_contract: 'انتهاء عقد',
      death: 'وفاة',
      disability: 'عجز',
    },
  },
  // === AGENT_A (M2.8 Workforce + Payroll) END ===

  // === AGENT_I (Frontend Set 2) BEGIN ===
  boqWizard: {
    title: 'معالج استيراد BOQ',
    subtitle: 'خطوات موجهة لرفع جدول الكميات وتطبيقه على المشروع',
    step1: 'الخطوة 1: المشروع',
    step2: 'الخطوة 2: رفع الملف',
    step3: 'الخطوة 3: قالب الاستشاري',
    step4: 'الخطوة 4: مطابقة الأعمدة',
    step5: 'الخطوة 5: معاينة البنود',
    step6: 'الخطوة 6: التطبيق',
    apply: 'تطبيق نهائي',
    next: 'التالي',
    back: 'السابق',
  },
  letters: {
    inbox: 'المراسلات الرسمية',
    new: 'إنشاء مراسلة',
    subject: 'الموضوع',
    recipient: 'المستلم',
    body: 'المحتوى',
    direction: 'الاتجاه',
    incoming: 'وارد',
    outgoing: 'صادر',
  },
  security: {
    center: 'مركز الأمان',
    twoFactor: 'تفعيل المصادقة الثنائية',
    auditLog: 'سجل التدقيق',
    sessions: 'الجلسات النشطة',
    policies: 'سياسات ABAC',
    suggestions: 'اقتراحات AI للأدوار',
    anomalies: 'الحالات الشاذة',
    revoke: 'إلغاء',
  },
  materials: {
    catalog: 'فهرس مواد البناء الإماراتي',
    requests: 'طلبات المواد',
    consumption: 'استهلاك المواد',
    theftAlerts: 'تنبيهات سرقة المواد',
  },
  sustainability: {
    nav: 'الاستدامة',
    dashboard: 'الاستدامة',
    certifications: 'شهادات الاستدامة',
    carbon: 'البصمة الكربونية',
    resources: 'المياه والكهرباء',
  },
  // === AGENT_I (Frontend Set 2) END ===

  // === STAGE4_P1H (Confidence visualization) BEGIN ===
  confidence: {
    level: {
      high: 'عالية',
      medium: 'متوسطة',
      low: 'منخفضة',
      veryLow: 'منخفضة جدًا',
    },
    meaning: {
      high: 'مطابقة قوية جدًا — يمكن قبولها دون مراجعة يدوية.',
      medium: 'مطابقة معقولة — يُنصح بإجراء فحص سريع.',
      low: 'مطابقة غير مؤكدة — راجع الاقتراح قبل قبوله.',
      veryLow: 'مطابقة ضعيفة — لا تقبلها بدون تحقق.',
    },
    improve: {
      high: [
        'لا حاجة لإجراء — مستوى الثقة قوي بالفعل.',
      ],
      medium: [
        'تأكد من تطابق الوحدة والكمية مع المستند الأصلي.',
        'أضف هذا البند إلى الكتالوج لتعزيز المطابقات المستقبلية.',
      ],
      low: [
        'أضف كلمات مفتاحية إضافية إلى بند الكتالوج.',
        'أرفق مستندًا داعمًا (رسم أو صورة أو ورقة مواصفات).',
        'اختر بند الكتالوج الصحيح يدويًا لتدريب النموذج.',
      ],
      veryLow: [
        'البيانات المصدر شحيحة — أثري الوصف أولاً.',
        'تحقق من أن الكتالوج يحتوي فعلاً على هذه المادة.',
        'يُوصى بشدة بمراجعة يدوية من مقدّر التكاليف.',
      ],
    },
    tooltip: {
      meaning: 'ما المقصود',
      improve: 'كيف ترفع الثقة',
      sources: 'المصادر المساهمة',
      aiReasoning: 'تفسير الذكاء الاصطناعي',
    },
    aria: {
      badge: 'الثقة: {{level}}، {{pct}}',
      bar: 'شريط الثقة: {{level}}، {{pct}}',
      circle: 'حلقة الثقة: {{level}}، {{pct}}',
    },
  },
  // === STAGE4_P1H (Confidence visualization) END ===

  // === STAGE4-P2E (Pricing UI) BEGIN ===
  pricing: {
    loading: 'جاري حساب سعر السوق…',
    samples: 'عينات',
    suggestion: {
      title: 'اقتراح السعر بالذكاء الاصطناعي',
      range: 'النطاق المقترح للسعر',
    },
    range: {
      low: 'الأدنى',
      avg: 'المتوسط',
      high: 'الأعلى',
    },
    confidence: {
      label: 'الثقة',
      low: 'منخفضة',
      medium: 'متوسطة',
      high: 'مرتفعة',
    },
    trend: {
      rising: 'في ارتفاع',
      stable: 'مستقر',
      falling: 'في انخفاض',
      unknown: 'الاتجاه غير معروف',
    },
    sources: {
      title: 'مصادر التسعير',
      history: 'سجل المشاريع',
      historical: 'أسعارنا السابقة',
      govt: 'البيانات الحكومية',
      crowd: 'تسعير جماعي',
      ai: 'نموذج الذكاء الاصطناعي',
    },
    actions: {
      accept: 'قبول الاقتراح',
      override: 'تعديل',
      overridePlaceholder: 'سعر مخصص',
      bulkApply: 'تطبيق الأسعار المقترحة',
      bulkApplied: 'تم تطبيق {{applied}} سعر · {{skipped}} مستثنى',
      rateUpdated: 'تم تحديث السعر',
    },
    history: {
      title: 'سجل الأسعار',
      period: 'الفترة',
      empty: 'لا يوجد سجل بعد',
      periods: {
        '1m': 'شهر',
        '3m': '٣ أشهر',
        '6m': '٦ أشهر',
        '1y': 'سنة',
      },
    },
    error: {
      title: 'فشل اقتراح السعر',
      generic: 'تعذر تحميل الاقتراح. حاول لاحقاً.',
      history: 'تعذر تحميل سجل الأسعار.',
    },
    market: {
      yourRate: 'سعرك',
      marketAvg: 'متوسط السوق',
      variance: 'الفارق',
      withinRange: 'ضمن نطاق السوق',
      moderate: 'فارق متوسط',
      outOfRange: 'خارج نطاق السوق',
      unknown: 'لا توجد بيانات سوق',
    },
    column: {
      aiSuggestion: 'سعر الذكاء',
      suggest: 'اقتراح',
    },
    rateReview: {
      badge: 'السعر يحتاج مراجعة المُقدِّر',
      replaced: 'تغيّر السعر التلقائي بعد وضعه — مراجعته ما زالت مفتوحة',
      setBy: 'وُضع تلقائياً من حصر الكميات ({{source}}) بتاريخ {{date}}',
      clear: 'تمت المراجعة',
      clearing: 'جارٍ الحفظ…',
      cleared: 'تم اعتماد السعر بعد المراجعة',
      noPermission: 'اعتماد السعر متاح فقط لمن يملك صلاحية التسعير',
    },
    dashboard: {
      title: 'لوحة الأسعار',
      subtitle: 'نظرة عامة على تكلفة المشروع مقارنة بمعايير السوق',
      overview: 'نظرة عامة على المشروع',
      totalEstimated: 'الإجمالي المقدر',
      marketAvg: 'متوسط السوق',
      varianceVsMarket: 'الفارق عن السوق',
      varianceAlertTitle: 'بنود ذات فوارق سعرية',
      varianceAlertBody: '{{count}} بنود تنحرف عن السوق بأكثر من 15%.',
      categoryTrends: 'اتجاهات التكلفة حسب الفئة',
      projectedVsActual: 'المخطط مقابل الفعلي',
      projected: 'المخطط',
      actual: 'الفعلي',
      topExpensive: 'أعلى البنود تكلفة',
      items: 'بنود',
      backToBoq: 'العودة إلى جدول الكميات',
      loadError: 'تعذر تحميل لوحة الأسعار.',
    },
  },
  // === STAGE4-P2E END ===

  // === STAGE4-P5B (One-Click Generate UI) BEGIN ===
  qtoGenerate: {
    badge: 'جديد · ميزة المرحلة 4 السحرية',
    title: 'أنشئ جدول الكميات والتسعير بضغطة واحدة',
    subtitle:
      'اختر المخططات، اضغط زرّاً واحداً، وشاهد ORKSTRA ينجز ثماني ساعات عمل في خمس دقائق.',
    stepper: {
      label: 'خطوات المعالج',
    },
    steps: {
      project: 'المشروع',
      specs: 'المواصفات',
      config: 'الإعدادات',
      review: 'المراجعة',
      generate: 'الإنشاء',
      progress: 'التقدم',
      results: 'النتائج',
    },
    actions: {
      runAgain: 'تشغيل من جديد',
    },
    comparison: {
      title: 'ثماني ساعات عمل → خمس دقائق سحر',
      body: 'حساب الكميات والتسعير اليدوي لبرج كهذا يستهلك يوماً كاملاً من مقدّر أول. ORKSTRA ينهي ذلك قبل أن يبرد فنجان قهوتك.',
      manualLabel: 'يدوياً',
      manualValue: '8 ساعات',
      orkstraLabel: 'ORKSTRA',
      orkstraValue: '5 دقائق',
      tryDemo: 'جرّب على مشروع توضيحي',
      dismiss: 'تجاهل',
    },
    project: {
      title: 'الخطوة 1 · المشروع والمخططات',
      subtitle:
        'حدّد المشروع المرتبط بهذه العملية والمخططات التي يقرأها الذكاء الاصطناعي.',
      name: 'اسم المشروع',
      namePlaceholder: 'مثال: برج الشيخ زايد',
      code: 'كود المشروع',
      drawings: 'المخططات المُختارة',
      tryDemoInline: 'ليس لديك مشروع؟ جرّب العرض التوضيحي المباشر →',
    },
    specs: {
      title: 'الخطوة 2 · المواصفات (اختياري)',
      subtitle:
        'ارفع ملف PDF للمواصفات حتى يربط الذكاء الاصطناعي البنود بالدرجة والتشطيب الصحيح.',
      dropzone: 'اسحب ملف PDF هنا أو اضغط للرفع',
      optional: 'اختياري — يعمل المعالج بدون هذا الملف.',
    },
    config: {
      title: 'الخطوة 3 · الإعدادات',
      subtitle: 'أخبر المعالج بدرجة الدقة المطلوبة وجهة المناقصة.',
      criticality: 'مستوى الأهمية',
      criticalityOptions: {
        simple: {
          title: 'بسيط',
          caption: 'نطاق متكرر — مرور واحد، الأسرع.',
        },
        complex: {
          title: 'مركّب',
          caption: 'متعدد التخصصات — موصى به لمعظم المناقصات.',
        },
        critical: {
          title: 'حرج',
          caption: 'عرض عالي القيمة — تحقق ثلاثي من الذكاء الاصطناعي.',
        },
      },
      tenderBody: 'الجهة المُستهدفة',
      tenderBodyPlaceholder: 'اختر الجهة',
      currency: 'العملة',
    },
    review: {
      title: 'الخطوة 4 · مراجعة الإعدادات',
      subtitle: 'آخر فرصة قبل الإطلاق. اضغط على أي خطوة سابقة للتعديل.',
      pipelineSteps: 'مراحل المعالجة',
      demoIndicator: 'مشروع توضيحي — يعمل على بيانات نموذجية بدون رفع حقيقي.',
    },
    generate: {
      title: 'جاهز للإنشاء',
      subtitle:
        'ضغطة واحدة تشغّل: المعايرة، كشف الرموز، القياس، ربط البنود بالـAI، التسعير، والتصدير.',
      cta: 'إنشاء BOQ + التسعير',
      demoNote: 'الوضع التوضيحي — النتائج مُسجلة مسبقاً للعرض التسويقي.',
    },
    pipeline: {
      calibrate: {
        label: 'جارٍ معايرة المخططات…',
        caption: 'قراءة مقياس الرسم وتثبيت إحداثيات الصفحة.',
      },
      detect_symbols: {
        label: 'جارٍ كشف الرموز…',
        caption: 'YOLO + نماذج AI متعددة تمسح كل ورقة.',
      },
      measure: {
        label: 'جارٍ قياس العناصر…',
        caption: 'استخراج الأطوال والمساحات والأحجام والأعداد تلقائياً.',
      },
      match_boq: {
        label: 'جارٍ ربط بنود BOQ (AI)…',
        caption: 'ربط كل قياس ببند مُسعّر بأسلوب Few-Shot.',
      },
      apply_pricing: {
        label: 'جارٍ تطبيق التسعير…',
        caption: 'دمج أسعار المنطقة مع المقارنات الجماعية.',
      },
      generate_exports: {
        label: 'جارٍ توليد الملفات…',
        caption: 'إكسل لـ BOQ، PDF للتسعير، وسجل تدقيق.',
      },
    },
    progress: {
      title: 'يجري السحر الآن',
      runningCaption: 'يتبقى نحو {{seconds}} ثانية — خذ فنجان قهوة بكل راحة.',
      completeCaption: 'تم. مرّر للأسفل لمشاهدة النتيجة.',
      cancelledCaption: 'تم الإلغاء. يمكنك التشغيل مجدداً متى شئت.',
      errorCaption: 'حدث خطأ. حاول مجدداً أو تواصل مع الدعم.',
      cancel: 'إلغاء التشغيل',
    },
    results: {
      title: 'انتهى السحر',
      subtitle: 'جدول الكميات والقياسات والتسعير جاهز. راجع ما رصده الذكاء أدناه.',
      summary: 'إحصاءات مختصرة',
      measurements: 'القياسات',
      boqItems: 'بنود BOQ المرتبطة',
      totalCost: 'إجمالي قيمة المشروع',
      confidence: 'توزيع ثقة الذكاء الاصطناعي',
      confidenceHigh: 'عالٍ (>95%)',
      confidenceMedium: 'متوسط (80–95%)',
      confidenceLow: 'منخفض (<80%) — يحتاج مراجعة',
      timeSaved: 'الوقت الموفّر',
      timeSavedCaption: 'مقارنة بالساعات الثماني اليدوية.',
      aiCost: 'تكلفة الذكاء الاصطناعي',
      aiCostCaption: 'دفع حسب الاستخدام.',
      viewBOQ: 'عرض BOQ',
      download: 'تنزيل الملفات',
      continueReview: 'المتابعة للمراجعة اليدوية',
    },
  },
  // === STAGE4-P5B (One-Click Generate UI) END ===

  // === AGENT_S4H (Asset / Equipment frontend) BEGIN ===
  equipment: {
    title: 'المعدات والأصول',
    subtitle: 'السجل، GPS، الصيانة، الوقود وساعات التشغيل.',
    addAsset: 'إضافة معدة',
    searchPlaceholder: 'ابحث بالكود أو الاسم أو الرقم التسلسلي…',
    emptyState: 'لا توجد معدات تطابق التصفية الحالية.',
    assetCode: 'كود الأصل',
    name: 'الاسم',
    manufacturer: 'الشركة المصنّعة',
    model: 'الموديل',
    serialNumber: 'رقم تسلسلي',
    year: 'سنة الصنع',
    purchaseCost: 'تكلفة الشراء',
    location: 'الموقع',
    currentProject: 'المشروع الحالي',
    notes: 'ملاحظات',
    specifications: 'المواصفات',
    shift: 'الوردية',
    hours: 'الساعات',
    project: 'المشروع',
    status: {
      all: 'الكل',
      active: 'نشطة',
      idle: 'متوقفة',
      in_maintenance: 'تحت الصيانة',
      retired: 'مُستبعدة',
      lost: 'مفقودة',
    },
    nav: {
      gpsMap: 'خريطة GPS',
      maintenance: 'الصيانة',
      fuel: 'الوقود',
      costAllocation: 'توزيع التكلفة',
    },
    detail: {
      backToList: 'العودة إلى السجل',
      notFound: 'المعدة غير موجودة',
      tabs: {
        overview: 'نظرة عامة',
        hours: 'ساعات التشغيل',
        fuel: 'الوقود',
        maintenance: 'الصيانة',
        qr: 'رمز QR',
      },
      recentHours: 'ساعات التشغيل الأخيرة',
      recentFuel: 'تعبئات الوقود الأخيرة',
      activeSchedules: 'جداول الصيانة النشطة',
      maintenanceHistory: 'سجل الصيانة',
      noHours: 'لم تُسجَّل ساعات بعد.',
      noFuel: 'لم تُسجَّل تعبئات بعد.',
      noSchedules: 'لا توجد جداول صيانة.',
      noMaintenanceHistory: 'لا توجد سجلات صيانة بعد.',
    },
    gpsMap: {
      title: 'خريطة المعدات على GPS',
      subtitle: 'جميع المعدات التي تم تسجيل موقعها.',
      legend: 'المفتاح',
      empty: 'لا توجد إحداثيات GPS لأي معدة.',
    },
    maintenance: {
      title: 'جدول الصيانة',
      subtitle: 'الصيانة الوقائية والتصحيحية القادمة.',
      overdue: 'متأخرة',
      next7days: 'خلال 7 أيام',
      totalUpcoming: 'إجمالي القادم',
      overdueList: 'العناصر المتأخرة',
      daysOverdue: 'يوم متأخر',
      calendarTitle: 'التقويم',
      type: 'النوع',
      title2: 'العنوان',
      status: 'الحالة',
      totalCost: 'إجمالي التكلفة',
    },
    fuel: {
      title: 'تتبّع الوقود',
      subtitle: 'تعبئات الوقود والاستهلاك وتكلفة كل معدة.',
      addEvent: 'تسجيل تعبئة',
      equipment: 'المعدة',
      type: 'نوع الوقود',
      liters: 'اللترات',
      unitCost: 'سعر اللتر',
      totalCost: 'الإجمالي',
      totalLiters: 'إجمالي اللترات',
      totalEvents: 'إجمالي التعبئات',
      supplier: 'المورِّد',
      consumptionByAsset: 'الاستهلاك حسب المعدة',
      recent: 'الأحدث',
      empty: 'لا توجد تعبئات بعد.',
      eventCount: 'تعبئات',
      logged: 'تم تسجيل التعبئة',
    },
    utilization: {
      pct: 'نسبة الاستخدام',
      hours: 'ساعات',
      chartTitle: 'الاستخدام حسب المعدة',
      empty: 'لا توجد بيانات استخدام في الفترة المحددة.',
    },
    costAllocation: {
      title: 'توزيع التكلفة',
      subtitle: 'ساعات التشغيل الموزّعة حسب المشروع.',
      projectFilter: 'فلترة برقم المشروع',
      byProject: 'حسب المشروع',
      noAllocation: 'لا توجد ساعات تشغيل في هذه الفترة.',
      activeAssets: 'المعدات النشطة',
      perAssetTitle: 'تفصيل لكل معدة للمشروع',
      logCount: 'عدد السجلات',
    },
    qr: {
      title: 'ملصق QR لمكافحة السرقة',
      print: 'طباعة الملصق',
      downloadPng: 'تنزيل PNG',
    },
  },
  // === AGENT_S4H (Asset / Equipment frontend) END ===

  // === AGENT_S4Q (AI Auto-Takeoff Phase 2) BEGIN ===
  autoTakeoff: {
    pageTitle: 'الحصر التلقائي بالذكاء الاصطناعي',
    pageSubtitle: 'ارفع مخططاً وسيكتشف الذكاء الاصطناعي الجدران والأعمدة والكمرات والأبواب والنوافذ تلقائياً ويُجمّعها في جدول كميات.',
    newJobTitle: 'مهمة حصر جديدة',
    drawingId: 'رقم المخطط',
    projectId: 'رقم المشروع',
    complexity: 'مستوى التعقيد',
    complexitySimple: 'بسيط (Gemini فقط)',
    complexityComplex: 'معقد (Gemini + Claude)',
    complexityCritical: 'حرج (نموذج ثلاثي + مراجعة)',
    elementTypesLabel: 'أنواع العناصر',
    detectAll: 'اكتشف كل شيء',
    governmentToggle: 'مشروع حكومي / تنظيمي (يفرض الوضع الحرج)',
    startJob: 'بدء الحصر',
    startingJob: 'جارٍ البدء…',
    jobsListTitle: 'المهام الأخيرة',
    jobsEmpty: 'لا توجد مهام حصر تلقائي حتى الآن.',
    job: 'مهمة',
    status: 'الحالة',
    detectionsCount: '{{count}} اكتشاف',
    confidenceAvg: 'متوسط الثقة',
    review: 'مراجعة',
    deleteJob: 'حذف المهمة',
    deleteConfirm: 'هل تريد حذف هذه المهمة وكل اكتشافاتها؟',
    reviewTitle: 'مراجعة اكتشافات الذكاء الاصطناعي',
    reviewSubtitle: 'طبقة مرمّزة بالثقة — انقر على المستطيل لفحصه.',
    autoAcceptThreshold: 'حدّ القبول التلقائي',
    acceptAll: 'اقبل كل ما يفوق الحدّ',
    accepting: 'جارٍ القبول…',
    acceptResult: 'مقبول {{accepted}} · مُتجاهل {{skipped}}',
    pending: 'بانتظار المراجعة',
    accepted: 'مقبول',
    overlayCaption: 'طبقة الاكتشافات',
    sidePanelTitle: 'تفاصيل الاكتشاف',
    sidePanelEmpty: 'انقر على اكتشاف في الطبقة لفحصه.',
    elementType: 'نوع العنصر',
    // See en.ts: `confidence` is redeclared below as an object, so
    // this string was dead and TS1117 blocked the type gate.
    layer: 'الطبقة',
    page: 'الصفحة',
    dimensions: 'الأبعاد',
    rejectDetection: 'رفض الاكتشاف',
    rejectConfirm: 'هل تريد رفض هذا الاكتشاف؟ لن يُطبَّق على جدول الكميات.',
    applyEdits: 'حفظ التعديلات',
    edit: 'تعديل',
    cancelEdit: 'إلغاء',
    correctionSaved: 'تم حفظ التصحيح — تم تحديث حلقة التعلم.',
    correctionError: 'تعذّر حفظ التصحيح.',
    filterByType: 'تصفية حسب النوع',
    filterAll: 'الكل',
    reviewedOnly: 'المراجَع فقط',
    pendingOnly: 'المعلّق فقط',
    elements: {
      wall: 'جدار',
      column: 'عمود',
      beam: 'كمرة',
      slab: 'بلاطة',
      door: 'باب',
      window: 'نافذة',
      area: 'مساحة',
      stairs: 'سلم',
    },
    confidence_levels: {
      high: 'مرتفعة',
      medium: 'متوسطة',
      low: 'منخفضة',
    },
    confidence: {
      high: 'ثقة عالية',
      medium: 'ثقة متوسطة',
      low: 'ثقة منخفضة (حرج)',
    },
    rollups: {
      title: 'إجماليات الكميات',
      element: 'العنصر',
      count: 'العدد',
      length: 'الطول (م)',
      area: 'المساحة (م²)',
      volume: 'الحجم (م³)',
      unit: 'الوحدة',
      empty: 'لا توجد إجماليات بعد — شغّل المهمة لملء الكميات.',
    },
    boq: {
      title: 'مقترحات جدول الكميات',
      subtitle: 'طبّق الاكتشافات المقبولة على قسم جدول كميات في المشروع.',
      apply: 'تطبيق على جدول الكميات',
      applying: 'جارٍ التطبيق…',
      applied: 'تم التطبيق',
      empty: 'لا توجد اكتشافات مقبولة — راجع الطبقة بالأعلى.',
      bomMatched: 'مطابقة مع BOM #{{id}}',
      bomMissing: 'لا توجد مطابقة في الـ BOM',
    },
  },
  // === AGENT_S4Q (AI Auto-Takeoff Phase 2) END ===

  // === ACCOUNTING-COA-VIEW-01 BEGIN ===
  chartOfAccounts: {
    title: 'دليل الحسابات',
    subtitle: 'هيكل حسابات الأستاذ العام للمنشأة (للعرض فقط)',
    search: 'ابحث بالكود أو الاسم…',
    expandAll: 'توسيع الكل',
    collapseAll: 'طي الكل',
    code: 'الكود',
    name: 'الاسم',
    type: 'النوع',
    inactive: 'غير نشط',
    accountCount: '{{count}} حساب',
    empty: 'لا توجد حسابات',
    noMatch: 'لا توجد حسابات مطابقة لبحثك',
    error: 'تعذّر تحميل دليل الحسابات',
  },
  // === ACCOUNTING-COA-VIEW-01 END ===

  // === ACCOUNTING-GL-LEDGER-01 BEGIN ===
  accountLedger: {
    title: 'دفتر أستاذ الحساب',
    subtitle: 'قيود حساب واحد المرحّلة خلال نطاق فترات (للعرض فقط)',
    account: 'الحساب',
    selectAccount: 'اختر حسابًا…',
    fiscalYear: 'السنة المالية',
    periodFrom: 'من فترة',
    periodTo: 'إلى فترة',
    wholeYear: 'السنة كاملة',
    date: 'التاريخ',
    entry: 'القيد',
    description: 'البيان',
    debit: 'مدين',
    credit: 'دائن',
    runningBalance: 'الرصيد الجاري',
    openingBalance: 'الرصيد الافتتاحي',
    closingBalance: 'الرصيد الختامي',
    totals: 'الإجماليات',
    choosePrompt: 'اختر حسابًا وسنة مالية لعرض دفتر الأستاذ.',
    empty: 'لا توجد قيود مرحّلة لهذا الحساب في الفترة المحددة.',
    error: 'تعذّر تحميل دفتر أستاذ الحساب',
  },
  // === ACCOUNTING-GL-LEDGER-01 END ===

  // === B29 Lane A: permission-aware UI (UI-PERM-GUARDS-01 / PERM-DENIED-AR-01) ===
  // {{reason}} هي الجملة ثنائية اللغة من lib/permissionLabels.ts
  // (مثال: "يتطلب صلاحية اعتماد الفواتير — متاحة للمحاسب الأول").
  rbac: {
    requiresPermission: '{{reason}}',
    deniedAction: 'ليس لديك صلاحية لهذا الإجراء',
  },
}
